module.exports = __webpack_public_path__ + "img/ring_g_0_0_0.3095d442.png";